export const SCHOOLS = "schools",
  LOGS = "logs",
  GRADE_LEVELS = "gradeLevels",
  SECTIONS = "sections",
  EMPLOYEES = "employees",
  STUDENTS = "students",
  TEACHERS = "teachers",
  STAFFS = "staffs",
  IDX_STUDENTS = "students_index",
  IDX_EMPLOYEES = "employees_index",
  IDX_SECTIONS = "sections_index",
  IDX_SCHOOLS = "schools_index",
  ADVISERS = "advisers",
  ADVISORIES = "advisories",
  BUILDINGS = "buildings",
  CLASSROOMS = "classrooms",
  CLASSES = "classes",
  ATTENDANCE = "attendance",
  USER_REGISTRATIONS = "user_registrations",
  USER_ACCOUNTS = "user_accounts",
  USERS = "users",
  POSTS = "posts",
  VIDEO_MEETINGS = "video_meetings",
  NOTIFICATIONS = "notifications",
  SBM_DIRECTORIES = "sbm_directories",
  SBM_CONTENTS = "sbm_contents",
  GRADE_COMPONENTS = "grade_components",
  ASSESSMENTS = "assessments",
  CLASS_ACTIVITIES = "class_activities",
  MASTER_GRADING_SHEETS = "master_grading_sheets",
  VALUES = "values",
  ABSENCES = "absences",
  JOBS = "jobs",
  APPLICANTS = "applicants";

// ---------------------------------------------------------------------------
// Higher Education (HED) collections
// ---------------------------------------------------------------------------
/** Top-level collection for HED subject classes */
export const HE_CLASSES = "he_classes";
/** Subcollection under he_classes — CHED grade components (WW, PT, ME per period) */
export const HE_GRADE_COMPONENTS = "he_grade_components";
/** Subcollection under he_classes — individual score records per GC per period */
export const HE_ACTIVITIES = "he_activities";
/** Subcollection under he_classes — enrolled student grade docs */
export const HE_CLASS_STUDENTS = "students";
/** Subcollection under employees — links to HED classes assigned to a teacher */
export const HE_TEACHER_CLASSES = "he_classes";
/** Firestore collection for per-school, per-SY grade aggregation stats */
export const HE_GRADE_SUMMARIES = "he_grade_summaries";
export const PROGRAMS = "programs",
  PROGRAMS_IDX = "programs_index",
  HE_SUBJECTS = "he_subjects",
  HE_SUBJECTS_IDX = "he_subjects_index";

/**
 * Subcollection under schools/{schoolId}.
 * A document is created/overwritten here each time an instructor locks grades
 * for an he_class. Document ID = classId.
 * Fields include: classId, schoolId, schoolYear (e.g. "20262027_sem1"),
 * term, subjectCode, subjectTitle, instructorId, instructorName,
 * studentCount (live count at lock time), submittedAt, submittedBy,
 * status ("pending" | "accepted" | "returned"), reviewedAt, reviewedBy,
 * gradeSummary: { total, passed, failed, inc, drp, dist: { "1.0": n, … } }.
 */
export const GRADE_SUBMISSIONS = "grade_submissions";
